export { default } from './DocLink'
